export default [
  {
    title: 'Sales',
    section: 'store',
    order: 4,
    icon: 'shopping_cart',
    count: 12,
    items: [
      {
        title: 'Orders',
        component: 'orders',
        section: 'store'
      },
      {
        title: 'Quotes',
        component: 'quotes',
        section: 'store'
      }
    ]
  }
]
